/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SkillUpdateRequest = {
  /**
   * Version number to set as default
   */
  defaultVersion: string;
};

/** @internal */
export const SkillUpdateRequest$inboundSchema: z.ZodType<
  SkillUpdateRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  default_version: z.string(),
}).transform((v) => {
  return remap$(v, {
    "default_version": "defaultVersion",
  });
});
/** @internal */
export type SkillUpdateRequest$Outbound = {
  default_version: string;
};

/** @internal */
export const SkillUpdateRequest$outboundSchema: z.ZodType<
  SkillUpdateRequest$Outbound,
  z.ZodTypeDef,
  SkillUpdateRequest
> = z.object({
  defaultVersion: z.string(),
}).transform((v) => {
  return remap$(v, {
    defaultVersion: "default_version",
  });
});

export function skillUpdateRequestToJSON(
  skillUpdateRequest: SkillUpdateRequest,
): string {
  return JSON.stringify(
    SkillUpdateRequest$outboundSchema.parse(skillUpdateRequest),
  );
}
export function skillUpdateRequestFromJSON(
  jsonString: string,
): SafeParseResult<SkillUpdateRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillUpdateRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillUpdateRequest' from JSON`,
  );
}
